import { render } from "./Welcome.vue?vue&type=template&id=270ceffe&scoped=true"
import script from "./Welcome.vue?vue&type=script&lang=ts"
export * from "./Welcome.vue?vue&type=script&lang=ts"

import "./Welcome.vue?vue&type=style&index=0&id=270ceffe&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-270ceffe"

export default script